<script>
import { mapGetters } from 'vuex'

import PageSubmenu from '@/components/PageSubmenu.vue'

export default {
  components: { PageSubmenu },
  computed: {
    ...mapGetters(['domain']),
    links () {
      const array = [
        {
          label: `FAQ ${this.domain?.label}`,
          path: '/app/questions',
          roles: ['admin', 'director', 'community-manager']
        },
        {
          label: 'Paramètres',
          path: '/app/questions/parameters',
          roles: ['admin', 'community-manager']
        },
        this.domain?.slug !== 'nosdroits' && {
          label: 'FAQ Code du travail',
          path: '/app/questions/universals',
          roles: ['admin', 'director', 'community-manager']
        }
      ]
      return array
    }
  },
  created () {

  }
}
</script>

<template>
  <PageSubmenu :links="links">
    <slot />
  </PageSubmenu>
</template>
